import script from "./SignPad.vue?vue&type=script&setup=true&lang=js"
export * from "./SignPad.vue?vue&type=script&setup=true&lang=js"

import "./SignPad.vue?vue&type=style&index=0&id=38c956e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38c956e0"]])

export default __exports__